import {percentageGroup, proposerHeadline} from '../../utils/step.fields.utils.js';

const step_schema_landlord = [
    {
        key: 'property_total',
        children: [
            {
                key: 'property_postcode',
                required_if: parent_value => parseInt(parent_value, 10) === 1
            }
        ]
    },
    {
        key: 'property_use',
    },
    {
        key: 'property_types',
        extra_children: [
            {key: 'property_type_flat'},
            {key: 'property_type_block_of_flats'},
            {key: 'property_type_room_only'},
            {key: 'property_type_house'},
            {key: 'property_type_cafe'},
            {key: 'property_type_shop'},
            {key: 'property_type_restaurant'},
            {key: 'property_type_industrial'},
            {key: 'property_type_warehouse'},
            {key: 'property_type_office'},
            {key: 'property_type_hotel'},
            {key: 'property_type_airbnb'},
            {key: 'property_type_other'},
        ],
        percentage_group: percentageGroup.PERCENTAGE_PROPERTIES,
    },
    {
        key: 'property_value',
    },
    //Proposer
    {
        key: 'driver_details',
        info: 'Details',
        extra_children: [
            {
                key: 'title',
                variant: 'inline',
                percentage_group: percentageGroup.PERCENTAGE_PROPOSER
            },
            {
                key: 'first_name',
                percentage_group: percentageGroup.PERCENTAGE_PROPOSER
            },
            {
                key: 'last_name',
                percentage_group: percentageGroup.PERCENTAGE_PROPOSER
            }
        ]
    },
    {
        key: 'telephone',
        percentage_group: percentageGroup.PERCENTAGE_PROPOSER
    },
    {
        key: 'email',
        percentage_group: percentageGroup.PERCENTAGE_PROPOSER
    },
    {
        key: 'date_of_birth',
        percentage_group: percentageGroup.PERCENTAGE_PROPOSER
    },
    {
        key: 'postcode',
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_PROPOSER
    },
    {
        key: 'address1',
        skip_question: true,
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_PROPOSER
    },
    {
        key: 'address2',
        skip_question: true,
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_PROPOSER
    },
    {
        key: 'address3',
        skip_question: true,
        headline: proposerHeadline,
        percentage_group: percentageGroup.PERCENTAGE_PROPOSER
    },
    {
        key: 'address4',
        skip_question: true,
        headline: 'Home',
        percentage_group: percentageGroup.PERCENTAGE_PROPOSER
    },
    {
        key: 'city',
        skip_question: true,
        headline: 'Home',
        required: false,
        percentage_group: percentageGroup.PERCENTAGE_PROPOSER
    },
    //policy
    {
        key: 'cover_date',
    },
    {
        key: 'cover_level',
        type: 'select',
        label: 'What do you need the cover for?',
        value: '',
        options: [],
        required: true,
    },
    {
        key: 'marketing',
        extra_children: [
            {key: 'marketing_phone'},
            {key: 'marketing_email'},
            {key: 'marketing_sms'},
        ],
    },
    {
        key: 'end',
    },
];
export default step_schema_landlord;
